import * as React from "react";

const SvgComponent = ({ width = "15px", height = "15px", color = "#1D1D1D", ...props }) => (
  <svg
  width={width}
  height={height}
  viewBox="0 0 15 15"

  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...props}
>
  <path
    d="m12.682 5.194-2.99-2.989.714-.713 2.989 2.989-.713.713ZM4.723 13.161l-2.989-2.99 7.44-7.437 2.988 2.99-7.44 7.437ZM14.573 3.338c.48-.48.48-1.249 0-1.729L13.324.36c-.48-.48-1.297-.48-1.729 0l-.624.625 3.026 3.026.576-.673ZM.019 14.388a.374.374 0 0 0 .096.384.367.367 0 0 0 .24.096H.5l3.603-1.297-2.786-2.786-1.297 3.603Z"
    fill={color}
  />
</svg>
  
);

export default SvgComponent;